<template>

  <div class="Menu">
    <div class="menuContainer">
      
      <router-link class="logoContainer" :to="{name: 'Dashboard'}">
        <img alt="ACG Advanced Communicaion Group" class="logoMain" src="@/assets/img/logo.svg" />
      </router-link>
      <router-link  :to="{name: 'Dashboard'}" class="menu__item space-left" >
        <img alt="Button Icon" class="menuButtonIcon" src="@/assets/img/icons/dashboard.svg" />
        <span>dashboard</span>
      </router-link>
      
     
      <!--<router-link v-if="$store.state.user.user_type == 'client'" :to="{path: '/client/'+$store.state.user.client[0].slug}" class="menu__item space-left" >
        <img alt="Button Icon" class="menuButtonIcon" src="@/assets/img/icons/dashboard.svg" />
        <span>dashboard</span>
      </router-link>-->
      <router-link v-if="$store.state.user.user_type != 'designer'" :to="{name: 'Accounts'}" class="menu__item space-left-second" >
        <img alt="Button Icon" class="menuButtonIcon" src="@/assets/img/icons/users.svg" />
        <span> Accounts & Designers</span>
      </router-link>
      <div class="menuRightButtons">
        <div class="menuButtonContainer">
          <button type="button">
           
            <span>{{$store.state.user.email}}</span>          
          </button>
          <button type="button" @click="logout()">
            <img alt="Button Icon" class="menuButtonIcon" src="@/assets/img/icons/logout.svg" />
            <span>logout</span>          
          </button>
        </div>
        <!-- <div class="menuButtonContainer"  v-if="this.$store.state.user.user_type != 'client'">       
           <addCreative
              v-if="this.$store.state.user.user_type == 'administrator' || this.$store.state.user.user_type == 'account'"
              ref="add_new_crea"              
              :customClass="'btn btn-green logoutBtn'"
          />
        </div> -->
      </div>
    </div>
  </div>

</template>

<script>
// import addCreative from "@/components/pagesComponents/brand/addCreative.vue";

export default {
    data(){
        return {
         
        }
    },
    components:{
      // addCreative
    },  
    methods:{
      logout(){
        
        //delete local storage
        localStorage.removeItem('ebus_token') 
        this.$store.state.token = null

        //go to login page
        this.$router.push({name: 'LogIn'})
      }
    }

}
</script>